import {Button} from 'antd'
import {exam_getExamQuestionSets_Api} from 'apis'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose, nest} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import ExaminationQuestionSetContext, {ExaminationQuestionSetProvider,} from 'views/AppLocals/Exam/ExaminationQuestionSetContext'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {renderExaminationQuestionSet} from './renderExaminationQuestionSet'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";

const renderQuestionsFooter = (item) => {
    return (
        <Translate>
            {(t) => (
                <div className="flex flex-col gap-1">
                    <ItemInformation
                        showIcon={true}
                        label="total of questions"
                        value={`${_.get(item, 'total_questions')} ${t('ask')}`}
                        className="text-sm italic"
                    />
                </div>
            )}
        </Translate>
    )
}

const ExaminationQuestionSets = ({
                                     owner_id,
                                     owner_type,
                                     Wrapper = 'div',
                                     filter_actions = {
                                         sortBy: 'sort-by',
                                         keyword: 'keyword',
                                         examination_id: 'examination',
                                     },
                                 }) => {
    const t = useTranslate()

    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const examination_id = useRouteSearchParam(filter_actions.examination_id)

    const {
        refreshKey,
        handleAction = NullAsDefault,
        renderContextMenu = NullAsDefault,
    } = useContext(ExaminationQuestionSetContext)

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                examination_id,
            })
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            renderItem: renderExaminationQuestionSet({
                renderContextMenu,
                renderFooter: renderQuestionsFooter,
                handleAction: (type, value) => {
                    handleAction(type, value)
                }
            }),
            apiInfo: exam_getExamQuestionSets_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        },
        filter_params: {
            owner_id,
            owner_type,
            examination_id,
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        renderSearchBar: NullAsDefault,
        query_params: filter_actions,
        AdvancedFilter: NullAsDefault,
        renderFilter: NullAsDefault,
        dependencies: [owner_id, owner_type, examination_id],
        withKey: ({sortBy, keyword, filterBy}) =>
            [...refresh_deps, sortBy, keyword, JSON.stringify(filterBy)].join('/'),
    })
    return (
        <Wrapper className="flex flex-1 flex-col space-y-3">
            <ListHeader
                title="questions set"
                extra={
                    <Button
                        type="primary"
                        className="button-rounded-lg no-border"
                        onClick={() => {
                            handleAction(CRUD.CREATE)
                        }}>
                        {t('create')}
                    </Button>
                }
            />
            {pager_widget}
        </Wrapper>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(nest(ExaminationQuestionSetProvider, ExaminationQuestionSets))
